import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

const IconWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
    <div className="flex items-center justify-center h-12 w-12 rounded-full bg-green-200 text-green-800 flex-shrink-0">
        {children}
    </div>
);

const CreaAdModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
    const handleContactClick = () => {
        onClose();
        onOpenContactModal('Consulta sobre Crea.AD');
    };

    return (
        <ModalBase
            isOpen={isOpen}
            onClose={onClose}
            title="Crea.AD - Asesoría para Creadores"
            headerClassName="bg-green-900 border-green-700"
            titleClassName="text-white"
        >
            <div className="text-left">
                <p className="text-lg font-semibold text-amber-600 mb-6 text-center uppercase tracking-wider">
                    Creado por creadores con conocimiento legal y técnico
                </p>
                <p className="text-xl text-gray-700 mb-6">
                    Enfócate en crear, nosotros nos encargamos de los impuestos y la burocracia.
                </p>
                <p className="mb-8 text-gray-600">
                    Crea.AD es nuestra división especializada para Youtubers, Instagramers, Tiktokers y cualquier creador de contenido digital. Entendemos los retos únicos de tu profesión y te ofrecemos soluciones a medida para que optimices tus ingresos y trabajes con total tranquilidad.
                </p>

                <div className="space-y-6 mb-8">
                    <div className="flex items-start gap-4">
                        <IconWrapper>
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v.01"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        </IconWrapper>
                        <div>
                            <h4 className="font-semibold text-gray-800">Optimización Fiscal Internacional</h4>
                            <p className="text-gray-600">Estructuramos tus ingresos de plataformas como YouTube, Twitch, Patreon o OnlyFans para minimizar tu carga fiscal, aprovechando las ventajas de la fiscalidad andorrana.</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4">
                        <IconWrapper>
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                        </IconWrapper>
                        <div>
                            <h4 className="font-semibold text-gray-800">Defensa y Reputación Digital</h4>
                            <p className="text-gray-600">Te defendemos ante problemas con las plataformas (strikes, desmonetización), reclamaciones de derechos de autor y gestionamos crisis de reputación online.</p>
                        </div>
                    </div>
                </div>

                <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg">
                    <p className="font-semibold text-green-800">Con Crea.AD, no solo ahorras dinero, ganas un socio estratégico que protege tu carrera.</p>
                </div>
            </div>
            <div className="mt-10 pt-6 border-t border-gray-200 flex justify-end">
                <Button onClick={handleContactClick} variant="success" size="large">
                    Quiero saber más
                </Button>
            </div>
        </ModalBase>
    );
};

export default CreaAdModal;
